import { useEffect } from 'react';
import { useAppContext } from '@mfe-presentation/contexts/appContext';
import useNavigation from '@mfe-presentation/hooks/useNavigation';
import EstimationResult from '@mfe-presentation/pages/EstimationResult';
import EstimationUpdate from '@mfe-presentation/pages/EstimationUpdate';
import Form from '@mfe-presentation/pages/Form';
import Loading from '@mfe-presentation/pages/Loading';
import ProtectedRoute from '@mfe-presentation/routes/ProtectedRoute';
import { Navigate, Route, Routes } from 'react-router-dom';

const AppRouter = () => {
    const {
        estimations,
        config,
        stepNames,
        currentStep: { index },
    } = useAppContext();
    const { handleNavigation } = useNavigation();

    const handlePopState: EventListener = (e) => {
        e.preventDefault();
        handleNavigation('popstate');
    };

    useEffect(() => {
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [index]);

    return (
        <Routes>
            {/* prevent the application to be displayed at base path */}
            <Route
                path="/"
                element={<Navigate to={`${stepNames[0]}${window.location.search}`} replace />}
            />

            {Object.keys(config).map((stepName) => {
                if (stepName === 'update' || stepName === 'loading') return null;
                return <Route key={stepName} path={`${stepName}?`} element={<Form />} />;
            })}

            <Route
                path="loading"
                element={
                    <ProtectedRoute
                        shouldDisplay={Boolean(estimations.isFetching || estimations.id)}
                        element={Loading}
                        redirectTo={`${stepNames[0]}`}
                    />
                }
            />

            <Route
                path="result"
                element={
                    <ProtectedRoute
                        shouldDisplay={Boolean(estimations?.id)}
                        element={EstimationResult}
                        redirectTo={`${stepNames[0]}`}
                    />
                }
            />

            <Route path="update" element={<EstimationUpdate />} />

            <Route
                path="*"
                element={<Navigate to={`${stepNames[0]}${window.location.search}`} replace />}
            />
        </Routes>
    );
};

export default AppRouter;
